<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> داشبورد مدرسه </span>

    </div>

</div>

<div dir="rtl" class="form row gx-2 px-2 w-100 mt-2 py-1">

    <div class="row gx-2 gy-2 w-100 mt-2 ">

        <div id="chart1" class="col-12 justify-content-around d-flex row chart2 mb-5  rounded shadow mb-3">

            <div class="dirI">

                <p class="text-center f18 dirI"> تعداد شکایات به تفکیک مدرسه </p>

                <canvas id="myChart1" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart2" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <div class="dirI">

                <p class="text-center f18 dirI"> شکایات به تفکیک موضوع </p>

                <canvas id="myChart2" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div class="p-2 col-md-6 col-12 border border-2  rounded shadow">

            <p class="text-center f18  p-2 rounded"> شکایات به تفکیک وضعیت </p>

            <canvas id="myChart3" style="max-height: 350px !important;"></canvas>

        </div>

        <div class="p-2 col-12 border border-2  rounded shadow">

            <p class="text-center f18  p-2 rounded"> بهترین دانش آموزان </p>

            <canvas id="myChart4" style="max-height: 350px !important;"></canvas>

        </div>

        <div class="p-2 col-12 border border-2  rounded shadow">

            <p class="text-center f18  p-2 rounded"> چالشی ترین دانش آموز </p>

            <canvas id="myChart5" style="max-height: 350px !important;"></canvas>

        </div>

        <p class="sticky-top fw-bold text-center bg-blue-light py-2 mt-2" style="top:5.5%">

            نمودار درختی شکایات مدارس
    
        </p>
        
        <div echarts [autoResize]="true" [options]="options | async" id="totalVehicles" class="tree-chart border-bottom"></div>


    </div>


</div>